import React, { useState } from "react";
import { Auth } from "aws-amplify";
import strings from "../../constants/strings";
import { Form, Button, Row } from "react-bootstrap";
import {
  handleLogin,
  validatePassword,
  capitalizeSentence,
  handleCustomAuthLogin,
  validatePhoneNumber,
  handleForgotPassword,
} from "../../helper";
import { FaFacebookF, FaGoogle } from "react-icons/fa";
import ERRORS from "../../constants/errors";
import { FaKey } from "react-icons/fa";
import InputMask from "react-input-mask";

export default function EnterPassword(props) {
  const {
    handleFormChange,
    closeLoginModal,
    getLoggedInDetails,
    isMobile,
    setUser,
    usernameInput,
    showSignUpModal,
    handleFormInputChange,
    showAlert,
    askUsername,
  } = props;

  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState(null);

  function handleUserNotConfirmedException() {
    handleFormInputChange({
      target: { name: "username", value: usernameInput },
    });
    closeLoginModal();
    showSignUpModal(true);
  }

  function handleLoginOTPRedirect() {
    usernameInput && validatePhoneNumber(usernameInput)
      ? handleCustomAuthLogin(usernameInput)
          .then((user) => setUser(user))
          .then(() => showAlert("Login", "Login OTP sent successfully", true))
          .then(() => handleFormChange("otp"))
          .catch((error) => {
            if (error.code === "UserNotConfirmedException") {
              handleUserNotConfirmedException();
            } else if (error.code === "UserNotFoundException") {
              showAlert(
                "Login",
                "You are not registered with us. Please signup!",
                true
              );
              closeLoginModal();
              showSignUpModal();
            } else {
              showAlert("Login", `${error.message}.`);
            }
          })
      : showAlert("Login", ERRORS.INVALID_USERNAME);
  }

  const handleForgotPasswordRedirect = () => {
    if (usernameInput && validatePhoneNumber(usernameInput)) {
      handleForgotPassword(usernameInput)
        .then(() =>
          showAlert(
            "Forgot Password",
            "OTP sent on registered mobile number",
            true
          )
        )
        .then(() => handleFormChange("newpassword"))
        .catch((error) =>
          showAlert(
            "Forgot Password",
            `${error.message}. Unable to reset password. Please try again`
          )
        );
    } else {
      showAlert("Forgot Password", ERRORS.INVALID_USERNAME);
    }
  };

  const handleLoginSubmit = async () => {
    if (usernameInput && validatePhoneNumber(usernameInput)) {
      if (password && validatePassword(password)) {
        await handleLogin(usernameInput, password)
          .then((user) => getLoggedInDetails(user))
          .then(() => showAlert("Login", "Logged in successfully", true))
          .then(() => closeLoginModal())
          .catch((error) => {
            if (error.code === "UserNotConfirmedException") {
              showAlert(
                "Login",
                "User Signup not confirmed. Please confirm signup.",
                true
              );
              handleUserNotConfirmedException();
            } else if (error.code === "UserNotFoundException") {
              showAlert(
                "Login",
                "You are not registered with us. Please signup!",
                true
              );
              closeLoginModal();
              showSignUpModal();
            } else {
              showAlert(
                "Login",
                `${error.message}. Something went wrong. Please try again.`
              );
            }
          });
      } else {
        showAlert("Login", ERRORS.INVALID_PASSWORD);
      }
    } else {
      showAlert("Login", ERRORS.INVALID_USERNAME);
    }
  };

  return (
    <div className="landing-form">
      <Form
        onSubmit={async (event) => {
          event.preventDefault();
          handleLoginSubmit();
        }}
      >
        <Row className="d-block">
          <Form.Group>
            {askUsername && (
              <Form.Group>
                <Form.Label className="landing-label">
                  {strings.USERNAME}
                </Form.Label>
                <InputMask
                  mask="+\919999999999"
                  maskChar={null}
                  className="landing-input form-control"
                  placeholder={capitalizeSentence(
                    `${strings.ENTER} ${strings.PHONENUMBER}`
                  )}
                  name="username"
                  value={usernameInput || ""}
                  onChange={handleFormInputChange}
                />
              </Form.Group>
            )}
            <Form.Label className="landing-label">
              {strings.PASSWORD}
            </Form.Label>
            <div className="d-flex">
              <FaKey
                size="15"
                color="#ac8d30"
                className={isMobile ? "password-key-mobile" : "password-key"}
                onClick={() => setShowPassword(!showPassword)}
              />
              <Form.Control
                className="landing-input"
                type={showPassword ? "text" : strings.PASSWORD}
                placeholder="Enter Password"
                value={password || ""}
                onChange={(event) =>
                  setPassword(
                    event.target.value === "" ? null : event.target.value
                  )
                }
              />
            </div>
          </Form.Group>
          <div className="d-flex justify-content-center">
            <div
              className="landing-links"
              onClick={handleForgotPasswordRedirect}
            >
              <p>{strings.FORGOTPASSWORD}</p>
            </div>
            <div
              className="landing-links ml-4"
              onClick={handleLoginOTPRedirect}
            >
              <p>{strings.OTP_LOGIN}</p>
            </div>
          </div>
        </Row>
        <Row className="mt-4">
          <Form.Group className="d-flex justify-content-center w-100">
            <Button
              variant="outline-warning"
              className="landing-button w-50"
              type="submit"
            >
              login
            </Button>
          </Form.Group>
        </Row>
      </Form>
      <div
        className="d-flex justify-content-center mt-2 landing-links"
        onClick={() => {
          closeLoginModal();
          showSignUpModal();
        }}
      >
        <p>Sign Up Manually</p>
      </div>
      <div className={`mx-auto mt-3 ${isMobile ? "w-100" : "w-50"}`}>
        <Button
          className="w-100"
          style={{ backgroundColor: "#3B5998", border: "none" }}
          onClick={async () =>
            await Auth.federatedSignIn({ provider: "Facebook" })
          }
        >
          <FaFacebookF color="white" /> Login/Signup using Facebook
        </Button>
      </div>
      <div className={`mx-auto mt-2 ${isMobile ? "w-100" : "w-50"}`}>
        <Button
          className="w-100"
          style={{ backgroundColor: "#dd4b39", border: "none" }}
          onClick={async () =>
            await Auth.federatedSignIn({ provider: "Google" })
          }
        >
          <FaGoogle color="white" className="mr-2" />
          Login/Signup using Google
        </Button>
      </div>
    </div>
  );
}
